/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useLazyQuery } from '@apollo/client';
import { GET_CHALLENGE_IDEAS, Idea } from '@frontend/data-access';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { IdeaCardUser } from '@frontend/feature-idea';
import { Empty, Spin } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useEffect } from 'react';

/* eslint-disable-next-line */
export interface ChallengeIdeaProps {
  challengeId: string;
}

export function ChallengeIdea({ challengeId }: ChallengeIdeaProps) {
  const { t } = useTranslation('common');

  const [getData, { data, loading }] = useLazyQuery<{
    challengeIdeas: Idea[];
  }>(GET_CHALLENGE_IDEAS);

  useEffect(() => {
    getData({
      variables: {
        challengeId,
      },
    });
  }, [challengeId, getData]);

  if (loading) {
    return (
      <div className="p-6 text-center">
        <Spin />
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className="font-semibold mb-4">{t('ideas')}</div>
      <div className="space-y-6">
        {data?.challengeIdeas.length ? (
          data?.challengeIdeas.map((idea, index) => (
            <IdeaCardUser key={index} data={idea} />
          ))
        ) : (
          <div>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={t('no_idea_application')}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ChallengeIdea;
